






















































































































import { Component, Vue, Prop, Watch, Mixins } from "vue-property-decorator";
import { Notify } from "quasar";
import FormValidator from "@/components/mixins/FormValidator.ts";

@Component
export default class UserRegistroComponent extends Mixins(FormValidator) {
  private mounted() {}

  private verValidador(tipo: string) {
    this.$router.push({ name: "resultado" }).catch(err => {});
    window.scrollTo(0, 0);
  }

  private verFormulario() {
    this.$router.push({ name: "formulario" }).catch(err => {});
    window.scrollTo(0, 0);
  }
}
